import styled from 'styled-components'

export const Container = styled.header`
  margin-top: 74px;
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
